/// <amd-module name="Artifacts/Upack/redux/Module" />
import { PackageModule } from "Artifacts/Package/redux";
import { rootSaga } from "Artifacts/Upack/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _UpackModule: ISagaModule<Record<string, never>> = {
  id: "upack-protocol-module",
  reducerMap: {},
  sagas: [rootSaga],
};

export const UpackModule = [PackageModule, _UpackModule];
